<template>

<div class="container main-content">
	
	<div class="row">

		<div class="col-md-1 offset-0 offset-md-2 col-12 pb-md-0 pb-3 header-container text-center">
			<div class="stopwatch" alt="Stopwatch"></div>
		</div>
		
		<div class="col-md-6 col-12 header-container text-center">
			<h2 class="lrg primary-highlight">Thank you for your order.  Please complete your payment</h2>
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-md-8 offset-md-2 text-center">
			<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
		</div>
	</div>

	<div class="row justify-content-center pt-2 interac-logo">
		<img src="./../assets/img/interac.png" class="img-fluid float-left">
	</div>
	<div class="row justify-content-center pt-2 pb-5">
		<small class="text-muted" style="font-size:65%">®Trademark of Interac Corp. Used under license.</small>
	</div>

	<div class="row">
		<div class="offset-0 col-12 col-sm-8 offset-sm-2 mt-2 mb-3">
			<ul class="no-bullets pl-0 e-transfer-bullets">
				<li>Order Total: <strong class="dark-highlight">${{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}</strong></li>
				<li>{{ pq.cryptoCurrency }} Amount: <strong class="dark-highlight">{{pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}</strong></li>
				<li>Receiving Address: <strong class="dark-highlight"> {{ pq.cryptoAddress }} </strong></li>
			</ul>	
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-sm-10 offset-sm-1 panel pb-0">
			<div class="row">
				<div class="col-12 panel-padded-left">
					<ol class="large pr-3">
						<li>Click on the Payment Page button below.</li>
						<li>Follow the instructions on the window that opens.  Payments should be sent to our payment partner <strong>Bitfy</strong>.</li>
						<li>Once payment clears, we will send the coins and notify you.</li>
					</ol>
				</div>
				
			</div>
		</div>
	</div>
   
	<div class="row mt-0 btn-rounded-height">
		<div class="col-12 col-sm-10 offset-sm-1 panel panel-half-button text-center">
			<a href="#" id="payment-etransfer-next" v-if="!isProcessing" class="btn next-btn" v-on:click.prevent="openPaymentPage">OPEN PAYMENT PAGE</a>
			<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
		</div>
	</div>
	<div class="row">
		<div class="col-12 text-center mt-3">
			<small class="error mb-3" v-if="hasError">{{ errorMessage }}</small>
			<small>Payment instructions have been sent to your email for reference.</small><br />
			<small class="text-muted"><a href="#" v-on:click.prevent="done">Done?  Click here to return home.</a></small>
		</div>
	</div>

</div>

</template>

<script>
import { log } from 'util';
export default {
	data() {
		return {
			pq: this.$gstate.getFlowState(),
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			paymentPageUrl: null,
		}
	},
	created(){
		this.$emit('setRateHoldTimer', false);
		this.$emit('setLeaveNotification', false);
	},
	methods: {
		openPaymentPage: function() {

			if(this.$gstate.getFlowState().nextActionParams != null && this.$gstate.getFlowState().nextActionParams.redirectUrl != null){
				this.paymentPageUrl = this.$gstate.getFlowState().nextActionParams.redirectUrl
			}

			if(this.paymentPageUrl == null){
				this.getPaymentPageUrl();
				return;
			}

			var width = 900;
			var height = 760;

			if(window.innerWidth * 0.8 < width){
				width = window.innerWidth * 0.8;	
			}
			
			if(window.innerHeight * 0.8 < height){
				height = window.innerHeight * 0.8;
			}
			
			this.popupCenter(this.paymentPageUrl, 'Payment Page', width, height);

		},
		getPaymentPageUrl(){
			this.isProcessing = true;
			var urlstr = this.$gstate.getApiBaseRootURL() + '/etransfer/init';
			this.axios.post(urlstr, {
				refId : this.pq.refId
			},
			this.$gstate.getAxiosHeaders())
				.then(response => {

					this.isProcessing = false;
					this.paymentPageUrl = response.data.nextActionParams.redirectUrl
					this.openPaymentPage();

				})
				.catch(error => {
					this.hasError = true;
					this.isProcessing = false;

					if(error.response.data.error.code == "TXNSTATUS.INVALID"){
						this.errorMessage = "Payment Instructions have already been initiated.  Please contact our support if you feel this is a mistake."
					} else {
						this.errorMessage = error.response.data.error.msg;
					}

				});

		},
		popupCenter: function(url, title, w, h) {

			// Fixes dual-screen position                         Most browsers      Firefox
			var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
			var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

			var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			var systemZoom = width / window.screen.availWidth;
			var left = (width - w) / 2 / systemZoom + dualScreenLeft
			var top = (height - h) / 2 / systemZoom + dualScreenTop
			var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);

			// Puts focus on the newWindow
			if (window.focus) newWindow.focus();
		},
		done: function (){
			this.$emit('reset', false);
			this.$gstate.redirectSuccess();
		}
	}
}
</script>
